import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

interface IUserData {
  username: string;
  first_name: string;
  last_name: string;
}

export interface IUserAuth {
  isLoggedIn: boolean;
  data: IUserData | null;
}

const initialState: IUserAuth = {
  isLoggedIn: false,
  data: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setMe: (state, payload: PayloadAction<IUserAuth>) => {
      state.isLoggedIn = payload.payload.isLoggedIn;
      state.data = payload.payload.data;
    },
  },
});

export const selectUserData = (state: RootState) => state.user;
export const selectIsLoggedIn = (state: RootState) => state.user.isLoggedIn;

export const { setMe } = userSlice.actions;
export default userSlice.reducer;
